import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    summary: {
      date: 'Date',
      description: 'Description',
      limitPaymentAll: 'Requested amount',
      requester: 'Applicant',
    },
    titles: {
      budgetCard: 'Budget card request',
      physicalCard: 'Physical card request',
      virtualCard: 'Virtual card request',
    },
  },
  fr: {
    summary: {
      date: 'Date',
      description: 'Description',
      limitPaymentAll: 'Budget demandé',
      requester: 'Demandeur',
    },
    titles: {
      budgetCard: 'Carte virtuelle à budget',
      physicalCard: 'Demande de carte physique',
      virtualCard: 'Demande de carte virtuelle',
    },
  },
} as const);

export default locales;
